import Service from '@ember/service';

import { service } from '@ember/service';
import { tracked } from 'tracked-built-ins';

import transitionHasRoute from 'rise-ui/utils/transition-has-route.js';

export default class DebugMenuService extends Service {
  @service router;

  components = tracked([]);

  register(route, component) {
    this.router.on('routeDidChange', transition => {
      if (transitionHasRoute(transition, route)) {
        this.add(component);
      } else {
        this.remove(component);
      }
    });
  }

  add(component) {
    if (!this.components.includes(component)) {
      this.components.push(component);
    }
  }

  remove(component) {
    const index = this.components.indexOf(component);
    if (index >= 0) {
      this.components.splice(index, 1);
    }
  }
}
